const ZERO_OPACITY = 0;
const HALF_OPACITY = 0.5;
const DRAWING_COMMIT = 'editable:drawing:commit';

export { ZERO_OPACITY, HALF_OPACITY, DRAWING_COMMIT };
